import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
	type UpdateStageTemplateInput,
	updateStageTemplate,
} from "@/adapters/api";

export function useUpdateStageTemplate(templateId: string | undefined) {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (input: UpdateStageTemplateInput) => {
			if (!templateId) throw new Error("missing template");
			return updateStageTemplate(templateId, input);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["stage-templates"] });
			queryClient.invalidateQueries({
				queryKey: ["stage-template", templateId],
			});
		},
	});
}
